import React from 'react';
import { getLatestUserCookie } from "../Login/user_session";
import { get } from "../../utils";
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
var RedirectToReturnUrl = function RedirectToReturnUrl() {
  var sitecoreContext = useSitecoreContext();
  var identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  var clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  var clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  React.useEffect(function () {
    getLatestUserCookie(identityGlobal, clientId, clientSecret).then(function (value) {
      var userCookie = value;
      if (typeof window !== 'undefined') {
        var urlParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
        var redirect_url = urlParams.get('redirect_url');
        if (redirect_url) {
          if (userCookie && userCookie.access_token) {
            window.location = redirect_url;
          } else {
            window.location.pathname = "/login";
          }
        }
      }
    });
  }, []);
  return null;
};
export default RedirectToReturnUrl;